// Per-username access rules that sit on top of the normal permission system.
//
// Super admins bypass all permission checks (see usePermission.ts and the
// backend StaffAuthGuard), so the `permissions` JSON cannot be used to limit a
// super-admin operator. These username-based rules can.

// Operators who get a READ-ONLY view of the hierarchy / "Ilova ekranlari" screen.
// They can open and view it, but cannot add / edit / delete / reorder / save / reset
// or upload-delete screenshots. Enforced both in the UI (controls hidden) and on
// the backend (writes rejected). Keep in sync with
// api/src/hierarchy/hierarchy.controller.ts (HIERARCHY_READONLY_USERNAMES).
export const HIERARCHY_READONLY_USERNAMES = [
  'muhammadrizo801', // #801
  'sevara802',       // #802
  'alisher803',      // #803
  'sarvinoz804',     // #804
  'sanjar805',       // #805
  'dilshoda810',     // #810
];

export function isHierarchyReadOnly(username?: string | null): boolean {
  return !!username && HIERARCHY_READONLY_USERNAMES.includes(username);
}
